// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"5870":"d63582cc","7892":"30c10307"}[chunkId] + ".css";
};